import { gql } from '@apollo/client';
import { GRANT_DETAIL_FIELDS, GRANT_TRANSACTION_FIELDS } from '../queries/Grants';

export const UPDATE_GRANT_SETTINGS = gql`
  mutation UpdateGrantSettings($input: UpdateGrantSettingsInput!) {
    updateGrantSettings(input: $input) {
      reviewRequired
      financialYearStartMonth
      defaultCurrency
    }
  }
`;

export const SET_GRANT_USER_ACCESS = gql`
  mutation SetGrantUserAccess($input: SetGrantUserAccessInput!) {
    setGrantUserAccess(input: $input) {
      userId
      name
      email
      role
      level
      isOrganisationAdmin
    }
  }
`;

export const SAVE_GRANT = gql`
  mutation SaveGrant($input: SaveGrantInput!) {
    saveGrant(input: $input) {
      ${GRANT_DETAIL_FIELDS}
    }
  }
`;

export const SAVE_GRANT_TRANSACTION = gql`
  mutation SaveGrantTransaction($input: SaveGrantTransactionInput!) {
    saveGrantTransaction(input: $input) {
      ${GRANT_TRANSACTION_FIELDS}
    }
  }
`;

export const DELETE_GRANT_TRANSACTION = gql`
  mutation DeleteGrantTransaction($id: ID!) {
    deleteGrantTransaction(id: $id) {
      id
    }
  }
`;

export const GRANT_RECORD_ACTION = gql`
  mutation GrantRecordAction($input: GrantRecordActionInput!) {
    grantRecordAction(input: $input) {
      kind
      id
      status
      reviewComment
    }
  }
`;

export const REVIEW_GRANT_IMPORT_BATCH = gql`
  mutation ReviewGrantImportBatch($input: ReviewGrantImportBatchInput!) {
    reviewGrantImportBatch(input: $input) {
      approved
      returned
      skipped
      messages
    }
  }
`;

const IMPORT_SUMMARY = `
  grantsToCreate
  grantsToUpdate
  grantsSkipped
  transactionsToCreate
  transactionsToUpdate
  transactionsSkipped
`;

export const VALIDATE_GRANT_IMPORT = gql`
  mutation ValidateGrantImport($input: GrantImportInput!) {
    validateGrantImport(input: $input) {
      type
      rowCount
      errors { sheet rowNumber column message }
      warnings { sheet rowNumber column message }
      summary { ${IMPORT_SUMMARY} }
    }
  }
`;

export const COMMIT_GRANT_IMPORT = gql`
  mutation CommitGrantImport($input: GrantImportInput!) {
    commitGrantImport(input: $input) {
      batchId
      fileName
      status
      summary { ${IMPORT_SUMMARY} }
      warnings { sheet rowNumber column message }
    }
  }
`;
